<div class="container">

    <p class="txt_nome_escola">{{ nome_escola }}</p>

    <app-stepper [recebeAba]="aba"></app-stepper>

    <div *ngIf="isLoading" class="loading">
        <mat-spinner></mat-spinner>
    </div>



    <form [formGroup]="form">
        <mat-card class="card" *ngIf="!isLoading" id="card">
            <mat-card-content>
                <div class="formulario">
                    <p>Informe o dados do responsável, selecione a forma de pagamento e clique no botão para finalizar o pedido.</p>
                    <div>
                      <mat-form-field class="input-50 mr-5">
                          <mat-label>Nome do Responsável</mat-label>
                          <input matInput formControlName="nome_responsavel">
                          <mat-error *ngIf="isInvalid('nome_responsavel')">
                              {{ mensagemDeErro('nome_responsavel') }}
                          </mat-error>
                      </mat-form-field>
                      <mat-form-field class="input-45">
                          <mat-label>CPF</mat-label>
                          <input matInput formControlName="cpf" mask="000.000.000-00">
                          <mat-error *ngIf="isInvalid('cpf')">
                              {{ mensagemDeErro('cpf') }}
                          </mat-error>
                      </mat-form-field>
                    </div>
                    
                    <div>
                      <mat-form-field class="input-50 mr-5">
                          <mat-label>E-mail</mat-label>
                          <input matInput formControlName="email">
                          <mat-error *ngIf="isInvalid('email')">
                              {{ mensagemDeErro('email') }}
                          </mat-error>
                      </mat-form-field>
                      <mat-form-field class="input-45">
                          <mat-label>Telefone</mat-label>
                          <input type="tel" matInput formControlName="fone_responsavel" mask="(00) 00000-0000||(00) 0000-0000">
                          <mat-error *ngIf="isInvalid('telefone')">
                              {{ mensagemDeErro('telefone') }}
                          </mat-error>
                      </mat-form-field>
                    </div>
                </div>


                <mat-accordion class="example-headers-align" multi>
                    <mat-expansion-panel *ngFor="let dependente of listaMateriais">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p>{{dependente.nome_dependente}}</p>
                                <p>Total por aluno: <strong>{{ totalPorDependente[dependente.id_dependente] ? (totalPorDependente[dependente.id_dependente] | currency:'BRL':'symbol':'1.2-2') : 0 | currency:'BRL':'symbol':'1.2-2'}}</strong></p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="tabela-resumo">
                            <table mat-table class="table" [dataSource]="dependente.produtos">
                                <ng-container matColumnDef="nome_dependente">
                                    <th mat-header-cell *matHeaderCellDef>Nome</th>
                                    <td mat-cell *matCellDef="let row">{{ row.desc_produto }}</td>
                                </ng-container>
                                <ng-container matColumnDef="valor">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Valor
                                    </th>
                                    <td mat-cell *matCellDef="let row">{{ row.valor_total | currency:'BRL':'symbol':'1.2-2' }}</td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                            </table>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-divider class="mat-divider-margin"></mat-divider>

                <div>
                    <p class="txt_frete"><strong>Total do carrinho:</strong> <strong>{{ total | currency:'BRL':'symbol':'1.2-2'}}</strong></p>
                </div>

                <mat-divider class="mat-divider-margin"></mat-divider>

                <div>
                    <p class="txt_frete"><strong>Frete:</strong> {{ frete == 0 ? 'Grátis' : (frete | currency:'BRL':'symbol':'1.2-2')}}</p>
                    <mat-divider></mat-divider>
                    <p class="txt_frete"><strong>Total do carrinho + Frete:</strong> <strong>{{ (frete + total) | currency:'BRL':'symbol':'1.2-2'}}</strong></p>
                </div>

                <mat-divider class="mat-divider-margin"></mat-divider>


                <div class="forma_pagamento" *ngIf="exibeFormaPagamento">
                    <label id="radio-group-label">Escolha a forma de pagamento: </label>
                    <mat-radio-group aria-labelledby="radio-group-label" class="radio-group" formControlName="id_forma_pagamento">
                        <mat-radio-button class="radio-button" *ngFor="let forma of forma_pagamento" [value]="forma.id_forma">
                            {{forma.descricao}}
                        </mat-radio-button>
                    </mat-radio-group>


                    <div class="formulario_cartao" *ngIf="formaPagamentoSelecionada == 1">
                        <mat-form-field class="input-45 mr-5">
                            <mat-label>Nome no cartão</mat-label>
                            <mat-hint align="start" class="hint-cartao">*Nome idêntico ao descrito no cartão.</mat-hint>
                            <input matInput maxlength="20" formControlName="titular" #titular placeholder="Nome descrito no cartão">
                            <!-- <mat-hint align="end">{{titular?.value?.length}} / 20</mat-hint> -->
                        </mat-form-field>

                        <mat-form-field class="input-50">
                            <mat-label>Número do cartão</mat-label>
                            <input matInput formControlName="numero_cartao" (input)="pegaBandeira()" (blur)="verificaBandeira(); desmarcarOpcaoBandeira();" maxlength="19">
                            <button matSuffix mat-icon-button type="button" [disabled]="true">
                                <img *ngIf="caminhoBandeira" [src]="caminhoBandeira" alt="Card Brand" />
                            </button>
                        </mat-form-field>

                        <div class="chips_cartoes" *ngIf="!temBandeira">
                            <mat-chip-listbox aria-label="Fish selection" (change)="selecionaAdministradora($event.value)">
                                <mat-chip-option [value]="1">
                                    <img [src]="'../../assets/bandeira-cartao/visa.svg'" alt="Card Brand" /> Visa
                                </mat-chip-option>
                                <mat-chip-option [value]="2">
                                    <img [src]="'../../assets/bandeira-cartao/mastercard.svg'" alt="Card Brand" /> MasterCard
                                </mat-chip-option>
                                <mat-chip-option [value]="3">
                                    <img [src]="'../../assets/bandeira-cartao/diners.svg'" alt="Card Brand" /> Diners
                                </mat-chip-option>
                                <mat-chip-option [value]="4">
                                    <img [src]="'../../assets/bandeira-cartao/amex.svg'" alt="Card Brand" /> Amex
                                </mat-chip-option>
                                <mat-chip-option [value]="5">
                                    <img [src]="'../../assets/bandeira-cartao/hipercard.svg'" alt="Card Brand" /> HiperCard
                                </mat-chip-option>
                                <mat-chip-option [value]="6">
                                    <img [src]="'../../assets/bandeira-cartao/elo.svg'" alt="Card Brand" /> Elo
                                </mat-chip-option>
                                <mat-chip-option [value]="7">
                                    <img [src]="'../../assets/bandeira-cartao/cabal.svg'" alt="Card Brand" /> Cabal
                                </mat-chip-option>
                            </mat-chip-listbox>
                        </div>

                        <mat-form-field class="input-30 mr-5">
                            <mat-label>Validade</mat-label>
                            <input matInput formControlName="validade" mask="m0/A0">
                        </mat-form-field>
                        <mat-form-field class="input-30 mr-5">
                            <mat-label>CVV</mat-label>
                            <input matInput formControlName="codigo_seguranca">
                        </mat-form-field>
                        <mat-form-field class="input-30">
                            <mat-label>Parcelas</mat-label>
                            <mat-select formControlName="quantidade_parcelas">
                                <mat-option *ngFor="let parcela of parcelas" [value]="parcela[0]">{{parcela[1]}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div class="observacoes">
                            <h3>Observações:</h3>
                            <p>- Antes de confirmar o pedido, verifique o resumo do mesmo na listagem acima.</p>
                            <p>- Seu pedido será enviado após aprovação do pagamento.</p>
                        </div>

                    </div>

                    <div class="boleto" *ngIf="formaPagamentoSelecionada == 3">
                        <img src="../../../assets/boleto.png" alt="Código de barras">
                        <p>Ao clicar em "Finalizar", será gerado o boleto para pagamento.</p>
                    </div>

                    <div class="pix" *ngIf="formaPagamentoSelecionada == 4">
                        <img src="../../../assets/pix.webp" alt="Logo PIX">
                        <p>Ao clicar em “Finalizar”, será gerado o QR Code PIX para pagamento.</p>
                    </div>
                </div>


                <div class="entrega" *ngIf="formaPagamentoSelecionada">
                    <mat-divider class="mat-divider-margin" *ngIf="formaPagamentoSelecionada"></mat-divider>

                    <h3>Prazo de Entrega:</h3>
                    <p>{{ prazo_entrega }}</p>

                    <h3>Endereço de Entrega:</h3>
                    <p><strong>{{nome_escola}}:</strong> {{endereco_escola}}</p>

                </div>
            </mat-card-content>

            <mat-card-actions>
                <button mat-button type="button" [routerLink]="'/endereco-entrega'"><mat-icon class="mat-18">arrow_back</mat-icon>VOLTAR</button>
                <button mat-raised-button color="primary" (click)="continuar(form)">FINALIZAR</button>
            </mat-card-actions>
        </mat-card>
    </form>
</div>